export default {
  setLots (state, lots) {
    state.lots = lots
  },
  setBuyRequests (state, buy_requests) {
    state.buy_requests = buy_requests
  }
}
